import ImageWrapper from "@/components/ImageWrapper";
import { minToHourConverter } from "@/helpers/useCommonFunctions";
import { RecipeImage } from "@/utils/constant";
import { Box, Button, Card, CardHeader, Text } from "@dxp-feed/ui";

const AutoCompleteCard = ({ selectRecipe, deleteSelectRecipe }: any) => {
  return (
    <Box
      as="div"
      className="px-0 mb-4 max-h-[200px] md:max-h-[160px] custom-scroll"
    >
      <Box as="div" className="grid grid-cols-1 gap-2 w-[100%]">
        {selectRecipe.map((item: any, index: any) => (
          <Card
            key={item.title + index}
            className="relative flex gap-3 w-full shadow-none rounded-[12px] border border-grey350 bg-white"
          >
            <Box
              as="div"
              className="relative bg-grey300 min-h-[72px] overflow-hidden pl-[80px] 3xs:pl-[100px] xs:pl-[128px]"
            >
              <ImageWrapper
                src={`${RecipeImage + item?.featuredImage || item?.featuredImage}`}
                alt={
                  item?.title
                    ? `${item.title} - a delicious recipe`
                    : "A recipe from our collection"
                }
                fill
                className="absolute top-0 left-0 object-cover"
              />
            </Box>
            <CardHeader className="border-none w-full py-2 xs:py-0 gap-1 xs:gap-3 flex flex-col xs:flex-row items-start xs:items-center justify-center xs:justify-between px-0 pr-2">
              <Box
                as="div"
                className="text-[14px] font-normal [&>strong]:font-bold line-clamp-1 xs:line-clamp-2"
              >
                {item.title}
              </Box>
              <Text as="ul" className="flex items-center">
                {item?.cooking?.totalTime ? (
                  <>
                    <Text
                      as="li"
                      className="flex items-center w-full justify-start xs:justify-end xs:min-w-[100px]"
                    >
                      <Text
                        as="span"
                        className="demo-icon icon-clock text-[19px] font-light flex items-center"
                      ></Text>
                      <Text as="span" className="py-0 px-2 text-[14px]">
                        {minToHourConverter(item?.cooking?.totalTime)}
                      </Text>
                    </Text>
                    <Text as="span">|</Text>
                  </>
                ) : (
                  ""
                )}
                <Button
                  onClick={() => deleteSelectRecipe(item.objectID)}
                  className="text-brandSecondary font-bold text-lg rounded-none"
                  aria-label={`Delete ${item.title} recipe`}
                  variant="icon"
                  size="none"
                >
                  <span className="demo-icon icon-bin text-[20px] text-brandBlack min-w-[48px] min-h-[20px] xs:min-h-[48px] flex items-center justify-center"></span>
                </Button>
              </Text>
            </CardHeader>
          </Card>
        ))}
      </Box>
    </Box>
  );
};

export default AutoCompleteCard;
